"use client";

import { useState, type FormEvent } from "react";
import { toast } from "sonner";

import { Input } from "@/components/ui/Input";
import { useSubscribeToNewsletter } from "@/features/newsletter/newsletter.queries";

export function NewsletterSignupForm() {
  const [email, setEmail] = useState("");
  const subscribe = useSubscribeToNewsletter();

  const handleSubmit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();
    if (!email.trim()) return;

    try {
      await subscribe.mutateAsync(email.trim());
      toast.success("Subscribed! Check your inbox for a confirmation email.");
      setEmail("");
    } catch {
      toast.error("Couldn't subscribe you right now. Please try again.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <Input
        type="email"
        value={email}
        onChange={(event) => setEmail(event.target.value)}
        placeholder="Enter your email"
        required
        disabled={subscribe.isPending}
        className="h-12 rounded-sm"
      />
      <button
        type="submit"
        disabled={subscribe.isPending}
        className="h-12 w-full rounded-sm bg-emerald-600 text-sm font-semibold text-white transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {subscribe.isPending ? "Subscribing..." : "Subscribe"}
      </button>
    </form>
  );
}
